import { GANGNAM_ROAD_REFERENCE } from './gangnamRoadReference.js'
import { EXTERNAL_ROUTE_PATHS } from '../shuttleExternalRoutePaths.js'

export const LONG_SEGMENT_THRESHOLD_M = 1500

export const SHUTTLE_ROAD_REFERENCES = {
  'gangnam-station->campus-sh': GANGNAM_ROAD_REFERENCE,
}

export const SHUTTLE_SEGMENT_GEOMETRY = {
  'gangnam-station->campus-sh': EXTERNAL_ROUTE_PATHS.gangnam_to_school,
  'gosaek-station->campus-inmundae': [
    { lat: 37.250887, lng: 126.981474 },
    { lat: 37.2417, lng: 126.9812 },
    { lat: 37.2316, lng: 126.9805 },
    { lat: 37.2224, lng: 126.9795 },
    { lat: 37.214146, lng: 126.978794 },
    { lat: 37.2141417070434, lng: 126.97878715656141 },
    { lat: 37.21316339241129, lng: 126.97819194832715 },
    { lat: 37.21304587508636, lng: 126.9781484669943 },
    { lat: 37.213009738333795, lng: 126.97813768781685 },
  ],
  'campus-inmundae->campus-sh': [
    { lat: 37.213009738333795, lng: 126.97813768781685 },
    { lat: 37.21248628988798, lng: 126.97804334917546 },
    { lat: 37.21206175575386, lng: 126.97792514473333 },
    { lat: 37.21203462887131, lng: 126.97791424425591 },
    { lat: 37.21180860388197, lng: 126.97782716225561 },
    { lat: 37.21092978238473, lng: 126.977275706079 },
    { lat: 37.2104692079038, lng: 126.97715799465591 },
    { lat: 37.20993694327193, lng: 126.97708631671345 },
  ],
  'campus-sh->campus-ict': [
    { lat: 37.20993694327193, lng: 126.97708631671345 },
    { lat: 37.209558041330546, lng: 126.97703510137082 },
    { lat: 37.20950082308397, lng: 126.97562762199394 },
    { lat: 37.20949955657054, lng: 126.97548118094001 },
  ],
  'campus-ict->campus-music': [
    { lat: 37.20949955657054, lng: 126.97548118094001 },
    { lat: 37.209489182541425, lng: 126.97532359703267 },
    { lat: 37.209497510281906, lng: 126.97524462233379 },
    { lat: 37.209577624689764, lng: 126.97513087868448 },
    { lat: 37.20969270623857, lng: 126.97489273536162 },
    { lat: 37.2097270883454, lng: 126.97470074745193 },
    { lat: 37.20973580571015, lng: 126.97466683135873 },
    { lat: 37.20973502560363, lng: 126.97457671353374 },
    { lat: 37.20973434295419, lng: 126.97449786043964 },
    { lat: 37.20943519480915, lng: 126.97325138256979 },
    { lat: 37.20954096966047, lng: 126.97297956496136 },
    { lat: 37.20958533536206, lng: 126.97290010150282 },
    { lat: 37.2096122673312, lng: 126.97288847043495 },
    { lat: 37.209783650443505, lng: 126.97290867955017 },
    { lat: 37.209766314387245, lng: 126.9729877768797 },
    { lat: 37.209766802717674, lng: 126.97304410051517 },
    { lat: 37.20978521312757, lng: 126.97308891522513 },
    { lat: 37.20980333055107, lng: 126.97309993575836 },
    { lat: 37.209830457855986, lng: 126.97311083419947 },
    { lat: 37.209884614807, lng: 126.97312136635944 },
    { lat: 37.20991154679704, lng: 126.97310973532123 },
    { lat: 37.20993838112649, lng: 126.97308683952163 },
    { lat: 37.209956205569085, lng: 126.97306406580921 },
    { lat: 37.209965020125075, lng: 126.97304141419227 },
    { lat: 37.20996472712796, lng: 126.97300761992244 },
    { lat: 37.209955424239375, lng: 126.97297394776736 },
    { lat: 37.209937013785385, lng: 126.97292913298668 },
  ],
  'campus-music->campus-eng1': [
    { lat: 37.209937013785385, lng: 126.97292913298668 },
    { lat: 37.209918798670465, lng: 126.97290684772659 },
    { lat: 37.20989167134809, lng: 126.97289594934698 },
    { lat: 37.209846621939406, lng: 126.97289655996211 },
    { lat: 37.209783650443505, lng: 126.97290867955017 },
    { lat: 37.2096122673312, lng: 126.97288847043495 },
    { lat: 37.20958533536206, lng: 126.97290010150282 },
    { lat: 37.20954096966047, lng: 126.97297956496136 },
    { lat: 37.20943519480915, lng: 126.97325138256979 },
    { lat: 37.20973434295419, lng: 126.97449786043964 },
    { lat: 37.20973502560363, lng: 126.97457671353374 },
    { lat: 37.20973580571015, lng: 126.97466683135873 },
    { lat: 37.2097270883454, lng: 126.97470074745193 },
    { lat: 37.20969270623857, lng: 126.97489273536162 },
    { lat: 37.209577624689764, lng: 126.97513087868448 },
    { lat: 37.209497510281906, lng: 126.97524462233379 },
    { lat: 37.209489182541425, lng: 126.97532359703267 },
    { lat: 37.20950082308397, lng: 126.97562762199394 },
    { lat: 37.209558041330546, lng: 126.97703510137082 },
    { lat: 37.20966476013319, lng: 126.97896015360855 },
    { lat: 37.20950442665411, lng: 126.9791763682984 },
    { lat: 37.209216304002254, lng: 126.97920278159802 },
    { lat: 37.209090165393704, lng: 126.97920448077807 },
  ],
  'campus-eng1->campus-backgate': [
    { lat: 37.209090165393704, lng: 126.97920448077807 },
    { lat: 37.20880184856376, lng: 126.97920836457845 },
    { lat: 37.208523415244755, lng: 126.97931350803567 },
    { lat: 37.2080572295278, lng: 126.97959016627262 },
    { lat: 37.20780582551083, lng: 126.97969494332064 },
    { lat: 37.20776067896336, lng: 126.97968428539588 },
    { lat: 37.207679201708295, lng: 126.97964031939331 },
    { lat: 37.20761622941006, lng: 126.97965243300415 },
    { lat: 37.207013924084286, lng: 126.979818261428 },
    { lat: 37.20700491417867, lng: 126.97981838271552 },
  ],
  'campus-backgate->campus-art': [
    { lat: 37.20700491417867, lng: 126.97981838271552 },
    { lat: 37.206708460350605, lng: 126.97992376384317 },
    { lat: 37.2065691396783, lng: 126.97944121908878 },
    { lat: 37.20660352932589, lng: 126.97924924101704 },
    { lat: 37.20666601623932, lng: 126.97918080581317 },
    { lat: 37.20698862527917, lng: 126.97897367871134 },
    { lat: 37.20770388128887, lng: 126.97832189438911 },
    { lat: 37.20791856423261, lng: 126.97813874759608 },
    { lat: 37.20788194156678, lng: 126.9780716467706 },
    { lat: 37.207782346755344, lng: 126.97801666100655 },
  ],
  'campus-art->campus-inmundae': [
    { lat: 37.207782346755344, lng: 126.97801666100655 },
    { lat: 37.207664732120115, lng: 126.97796191840685 },
    { lat: 37.20760127405183, lng: 126.9779177112925 },
    { lat: 37.20754633985714, lng: 126.97781706065948 },
    { lat: 37.20752773681214, lng: 126.97774971724785 },
    { lat: 37.20914309977326, lng: 126.97698437303197 },
    { lat: 37.209558041330546, lng: 126.97703510137082 },
    { lat: 37.2104692079038, lng: 126.97715799465591 },
    { lat: 37.21092978238473, lng: 126.977275706079 },
    { lat: 37.21180860388197, lng: 126.97782716225561 },
    { lat: 37.21203462887131, lng: 126.97791424425591 },
    { lat: 37.21206175575386, lng: 126.97792514473333 },
    { lat: 37.21248628988798, lng: 126.97804334917546 },
    { lat: 37.213009738333795, lng: 126.97813768781685 },
  ],
}
